import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  successIcon: {
    color: "green"
  },
  message: {
    fontSize: theme.spacing(2)
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center"
  }
}));
